import { h, Component } from 'preact';
import s from 'components/shared/socialShare/socialShare.sss';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import { getCopyWithParams } from 'utils/clientUtils';
import { Link } from 'components/core/link/link';
import { getCopy } from 'utils/copy';
// import Store from 'store/store';

const URLS = {
	facebook: 'https://www.facebook.com/sharer/sharer.php?u=%SHARE_URL%',
	twitter: 'https://twitter.com/intent/tweet?text=%SOCIAL_COPY%&url=%SHARE_URL%',
	pinterest: 'https://www.pinterest.co.uk/pin/create/button/?url=%SHARE_URL%&media=%PAGE_SHARE_IMAGE%&description=%SOCIAL_COPY%',
	email: 'mailto:?subject=%SOCIAL_COPY%&body=%SHARE_URL%',
	tumblr: 'http://www.tumblr.com/share/link?url=%SHARE_URL%/&description=%SOCIAL_COPY%',
	whatsapp: 'whatsapp://send?text=%SOCIAL_COPY% %SHARE_URL%',
	viber: 'viber://forward?text=%SHARE_URL% %SOCIAL_COPY%',
	telegram: 'https://telegram.me/share/url?url=%SHARE_URL%&text=%SOCIAL_COPY%'
};

export default class SocialShare extends Component {
	constructor(props) {
		super(props);

		this.state = {
			overlayActive: false,
			overlayVisible: false
		};

		if (props.isMobile == undefined) {
			console.error('Specify isMobile in props!');
		}

		if (props.shareCopy == undefined && (props.copy == undefined)) {
			console.error('Specify shareCopy in props, or pass in copy object in copy prop!');
		}

		if (!props.shareImage) {
			console.error('Pass an image url for Pinterest!');
		}

		this.renderVisibleItems = this.renderVisibleItems.bind(this);
		this.renderOverlay = this.renderOverlay.bind(this);
		this.updateOverlayState = this.updateOverlayState.bind(this);
		this.tryToClose = this.tryToClose.bind(this);
		this.closeConditions = { animationName: s['fade-out'] };
	}

	// DATA STUFF

	getShareableUrl(itemName) {
		let {
			shareCopy,
			copy,
			image = '',
			url,
			assetRoot,
		} = this.props;

		if (!url && typeof window !== 'undefined') {
			url = location.href;
		}
		if (!shareCopy) {
			shareCopy = getCopy('$SOCIAL_COPY', copy);
		}

		let itemUrl = URLS[itemName];
		if (!itemUrl) {
			return;
		}

		return getCopyWithParams({
			SHARE_URL: url,
			SOCIAL_COPY: shareCopy,
			PAGE_SHARE_IMAGE: image,
			IMAGE_REGION_ROOT: assetRoot.imageRegion,
			IMAGE_ROOT: assetRoot.image
		}, itemUrl);
	}

	// FUNCTIONS

	updateOverlayState() {
		this.setState({
			overlayVisible: !this.state.overlayVisible,
			overlayActive: true
		});
	}

	tryToClose(e) {
		const {
			target,
			animationName
		} = e;

		if (target === this.$overlay && animationName === this.closeConditions.animationName) {
			this.setState({
				overlayActive: false
			});
		}
	}

	// RENDERS

	renderItem(item, itemClass, hideShare) {
		const href = this.getShareableUrl(item.name);

		let share;
		if (!hideShare) {
			share = <span class={s.label}>Share</span>;
		}
		return (
			<Link
				href={href}
				key={item.name}
				target='_blank'
				class={itemClass}
				renderCustomChild
				aria-label={`Share on ${item.name}.`}
			>
				<span class={joinClasses(s.itemContent, s[item.name])}>
					{share}
				</span>
			</Link>
		);
	}

	renderVisibleItems(socialItems, isMobile) {
		return socialItems.filter(
			item => isMobile || ['whatsapp', 'viber', 'telegram'].includes(item.name)
		).map(
			item => this.renderItem(item, s.item, !isMobile)
		);
	}

	renderOverlay(remainingItems, visible) {
		return (
			<div
				class={joinClasses(visible ? s.visible : s.hidden, s.overlay)}
				ref={ref => this.$overlay = ref}
				onAnimationEnd={this.tryToClose}
			>
				<button class={s.close}
					onClick={this.updateOverlayState}
					aria-label={'Hide additional sharing options.'}
				/>
				<div class={s.overlayItems}>
					{remainingItems.map(item => this.renderItem(item, s.overlayItem))}
				</div>
			</div>
		);
	}

	render(props, state) {
		const {
			links,
			isMobile = true,
			inline
		} = props;

		const {
			overlayActive,
			overlayVisible,
		} = state;

		const socialItems = sortObjectByOrder(links);
		const first2Items = socialItems.slice(0, 2);
		const remainingItems = socialItems.slice(2);
		let wrapperClass = joinClasses(s.wrapper, props.class, inline ? s.inline : s.fixed);

		if (!isMobile) {
			return (
				<div class={wrapperClass}>
					<div class={s.container}>
						{this.renderVisibleItems(socialItems)}
					</div>
				</div>
			);
		}

		return (
			<div class={joinClasses(wrapperClass, overlayActive && s.overlayActive)}>
				<div class={s.container}>
					{this.renderVisibleItems(first2Items, isMobile)}
					{remainingItems.length &&
						<button class={s.expandButton}
							onClick={this.updateOverlayState}
							aria-label={'Show additional sharing options.'}
						/>
					}
				</div>
				{overlayActive && this.renderOverlay(remainingItems, overlayVisible)}
			</div>
		);
	}
}
